import { Box, Stack } from '@mui/material'
import { FigmaFile } from 'api'
import { DialogContent } from 'elements/feedback'
import { formatToDottedDateFormat } from 'lib/format/date'
import { useTranslation } from 'react-i18next'

import { IntegrationDetailsItem } from '../integration-details-item'

type FigmaIntegrationDetailsProps = {
  figmaFile: FigmaFile
  onClose: () => void
}

export const FigmaIntegrationDetails = ({
  figmaFile,
  onClose,
}: FigmaIntegrationDetailsProps) => {
  const { t } = useTranslation()

  const { fileId, fileName, createdAt } = figmaFile

  return (
    <DialogContent
      title={t('projects.settings.integrations.figma_file_details')}
      onDeny={onClose}
      hideCancelButton
    >
      <Stack spacing={3}>
        <Box display="flex">
          <IntegrationDetailsItem
            title={t('projects.settings.integrations.file_id')}
            value={fileId}
          />
          <IntegrationDetailsItem
            title={t('projects.settings.integrations.file_name')}
            value={fileName}
          />
        </Box>

        <IntegrationDetailsItem
          title={t('projects.settings.integrations.creation_date')}
          value={formatToDottedDateFormat(createdAt)}
        />
      </Stack>
    </DialogContent>
  )
}
